import React from 'react';
import { Grid, Form, Divider } from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { InputField, DropdownField } from 'Common/SemanticWrapper';
import { CreateEditTruckRouteScheduleEnum } from 'Common/FieldEnum';

import TruckRouteTimeComponent from './TruckRouteTimeComponent';
import TruckRouteScheduleGrid from './TruckRouteScheduleGrid';
import { WEEK_DAY_OPTIONS } from './../../helper';

const CreateEditTruckRouteScheduleComponent = props => {
  const {
    truckRouteListData,
    truckRouteListDataLoading,
    truckRouteScheduleDetailData,
    isNewEdit,
  } = props;

  return (
    <Form>
      <Grid>
        <Grid.Row>
          <Grid.Column width={7}>
            <Field
              name={CreateEditTruckRouteScheduleEnum.Description}
              component={InputField}
              type="text"
              label={'Description'}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Field
              options={WEEK_DAY_OPTIONS}
              placeholder="Select Day"
              search
              selection
              fluid
              multiple
              component={DropdownField}
              label={'Day(s)'}
              name={CreateEditTruckRouteScheduleEnum.DayOfWeek}
            />
          </Grid.Column>
        </Grid.Row>
        <Divider horizontal />
        <Grid.Row>
          <Grid.Column>Time(s)</Grid.Column>
        </Grid.Row>
        <Divider horizontal />
        <Grid.Row>
          <Grid.Column>
            <Field
              name={CreateEditTruckRouteScheduleEnum.TruckRouteTimeComponent}
              component={TruckRouteTimeComponent}
            />
          </Grid.Column>
        </Grid.Row>
        <Divider horizontal />
        <Grid.Row>
          <Grid.Column>
            <Field
              name={CreateEditTruckRouteScheduleEnum.TruckRouteScheduleGrid}
              component={TruckRouteScheduleGrid}
              {...{
                truckRouteListData,
                truckRouteListDataLoading,
                truckRouteScheduleDetailData,
                isNewEdit,
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form>
  );
};

CreateEditTruckRouteScheduleComponent.propTypes = {
  truckRouteListData: PropTypes.array,
  truckRouteListDataLoading: PropTypes.bool,
  truckRouteScheduleDetailData: PropTypes.object,
  isNewEdit: PropTypes.bool,
};

CreateEditTruckRouteScheduleComponent.defaultProps = {
  truckRouteListData: [],
  truckRouteListDataLoading: false,
  truckRouteScheduleDetailData: null,
  isNewEdit: false,
};

export default CreateEditTruckRouteScheduleComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/components/createedittruckrouteschedule/CreateEditTruckRouteSchedule.js